module.exports = {"id":"dp1_2l3q5","text":"Evaluating Information","instructions":"How important is it to question the credibility of AI-generated content?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.2","questionType":"Scale","random":false,"options":[{"id":"dp1_2l3q5-a1","text":"Not important","score":2},{"id":"dp1_2l3q5-a2","text":"Somewhat important","score":2.4},{"id":"dp1_2l3q5-a3","text":"Moderately important","score":3},{"id":"dp1_2l3q5-a4","text":"Very important","score":3.6},{"id":"dp1_2l3q5-a5","text":"Essential always","score":4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.2/l3q5.json
// module id = 953
// module chunks = 41